module.exports = __webpack_public_path__ + "media/images/games/clash-royale/card-common-6a0111362a2b176f57e731b63de42f86.png";